"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradesWebSocketV2 = void 0;
const rxjs_1 = require("rxjs");
const SubsPairMgr_1 = require("./base/SubsPairMgr");
const BaseWebSocket_1 = require("./BaseWebSocket");
const QuotationSocketMgr_1 = require("./QuotationSocketMgr");
class TradesWebSocketV2 extends BaseWebSocket_1.BaseWebSocket {
    constructor() {
        super(...arguments);
        this.tradeCacheData = new Map();
        this.tradePairPoolMgr = new SubsPairMgr_1.SubsPairMgr(QuotationSocketMgr_1.SubscribeEventType.trade, (type, param) => {
            return this.send(QuotationSocketMgr_1.SubscribeEventType.trade, param);
        });
        this.maxCount = 100;
        this.symbolCache = [];
        this.dataSymbolCache = new Map();
    }
    handleTradeData(pushData) {
        this.symbolCache.length = 0;
        this.dataSymbolCache.clear();
        pushData === null || pushData === void 0 ? void 0 : pushData.forEach((item, index) => {
            var _a;
            const parseValue = {
                base: item.b,
                quote: item.q,
                symbol: item.b + "/" + item.q,
                side: item.d,
                timestamp: item.t,
                price: Number(item.p),
                amount: Number(item.a),
                fee: 0,
                order: "",
                id: "",
                buyerMaker: false,
            };
            // 服务端默认升序。 1，2，3
            // 对新数据进行整合，后边的轮训再进行发送
            if (!this.dataSymbolCache.get(parseValue.symbol)) {
                this.symbolCache.push(parseValue.symbol);
                this.dataSymbolCache.set(parseValue.symbol, []);
            }
            (_a = this.dataSymbolCache.get(parseValue.symbol)) === null || _a === void 0 ? void 0 : _a.push(parseValue);
        });
        this.symbolCache.forEach((symbol) => {
            var _a;
            const arr = (_a = this.dataSymbolCache.get(symbol)) !== null && _a !== void 0 ? _a : [];
            const subject = this.tradeCacheData.get(symbol);
            if (!subject) {
                return;
            }
            let groupData = subject.value.concat(arr);
            if (groupData.length > this.maxCount) {
                // 如果长度超了，删除前面的老的
                groupData = groupData.slice(groupData.length - this.maxCount);
            }
            subject.next(groupData);
        });
    }
    /**
     * 订阅Trades(最新成交记录)推送
     * [{
     *    exchange: "pionex.v2",
     *    base: base,
     *    quote: quote,
     * }]
     * @param exchange
     * @param base
     * @param quote
     */
    getTradesObservable(exchange, base, quote) {
        this.tradePairPoolMgr.addSubscribePair([{ market: exchange, base: base, quote: quote }]);
        const symbol = `${base}/${quote}`;
        if (!this.tradeCacheData.get(symbol)) {
            this.tradeCacheData.set(symbol, new rxjs_1.BehaviorSubject([]));
        }
        return new rxjs_1.Observable((observer) => {
            var _a;
            const subscription = (_a = this.tradeCacheData.get(symbol)) === null || _a === void 0 ? void 0 : _a.subscribe((result) => {
                observer.next(result);
            }, (err) => { });
            observer.add(() => {
                subscription === null || subscription === void 0 ? void 0 : subscription.unsubscribe();
                this.tradePairPoolMgr.removeSubscribePair([
                    {
                        market: exchange,
                        base: base,
                        quote: quote,
                    },
                ]);
            });
        });
    }
}
exports.TradesWebSocketV2 = TradesWebSocketV2;
